// extracted by mini-css-extract-plugin
export var messageSideLeft = "_m3-1";
export var messageSideRight = "_m3-2";
export var orderLookupBubbleContainer = "_m3-0";
export var submitButton = "_m3-3";